<script lang="ts">
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { reformatUrlAndGetTargetValue } from "@shared/services/target_value_forward_urls";
  import { EventTracking } from "@shared/services/event_tracking/events";

  const { trackClick } = EventTracking;

  export let imageProps: Record<string, any> = {};
  let className: string | undefined | null = undefined;
  export { className as class };
  export let forwardLink: string = "";

  const { href, target } = reformatUrlAndGetTargetValue(forwardLink);
</script>

<style>
  .img-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  img {
    aspect-ratio: 16/9;
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
  }
</style>

<TrackingContext let:trackingContext>
  <a
    {href}
    {target}
    on:click={() => trackClick("shoppable_unit_hero_image", trackingContext.entities)}
  >
    <picture class="img-container">
      <img
        data-testid="shoppable-unit-hero-image"
        src={imageProps.src}
        alt={imageProps.alt}
        class={className}
        {...$$restProps}
      />
    </picture>
  </a>
</TrackingContext>
